// extracted by mini-css-extract-plugin
module.exports = {"list":"Itemss_list__2z9qA","card":"Itemss_card__19NKj","loader":"Itemss_loader__2EGQw"};